'use client'

import { useEffect } from 'react'
import useHouseSearchContext from '../context'
import FilterBathroom from './items/bathroom'
import FilterBedroom from './items/bedroom'
import FilterCategories from './items/categories'
import FilterFloorArea from './items/floorarea'
import MoreFilter from './items/moreFilter'
import FilterPrice from './items/price'
import FilterPropertyType from './items/propertyType'
// import FilterLandArea from './items/landarea'
import { RESIDENTIAL_FILTER } from '@homeSearch/modules/filter/config'
import useFetch from '@hooks/useFetch'
import { houseSearchType } from '@routerConfig'
import { global } from '@store/index'
import classNames from 'classnames'
import { assign } from 'lodash-es'
import { useBoolean, useUnmount } from 'react-use'
import { useRecoilValue } from 'recoil'
import FilterLivingOptions from './items/livingOptions'
import useParamsToFilter from './useParams2filter'

export default function SearchFilter({
  wrapClassName,
  className
}) {

  const { isMobile } = useRecoilValue(global)
  const { setFilterData, routeParams, state, filterMeta, filterOpen } = useHouseSearchContext()
  const { showMap } = state
  // mobile并且地图模式下不显示filter
  const [visible, toggleVisible] = useBoolean(false)

  // 把route上的参数转成houses/filter接口需要的参数
  const [filter, query] = useParamsToFilter({ routeParams, state, filterMeta })
  const { data, clear } = useFetch(query ? { url: RESIDENTIAL_FILTER.url, params: assign(query, filter ? { filter } : undefined) } : null)

  useUnmount(() => {
    clear()
  })

  useEffect(() => {
    setFilterData(data)
  }, [data, setFilterData])

  useEffect(() => {
    const mapCtrlTopRight = document.querySelector('.mapboxgl-ctrl-top-right')
    if (!mapCtrlTopRight) {
      return
    }

    mapCtrlTopRight.style.top = visible ? '50px' : 0
    return () => {
      mapCtrlTopRight.style.top = 0
    }
  }, [visible])

  const isCommercial = [houseSearchType.commercialForSale, houseSearchType.commercialForLease].includes(state.type)
  const isBusiness = [houseSearchType.business].includes(state.type)
  const isRural = [houseSearchType.rural].includes(state.type)
  const isVillage = [houseSearchType.retirementLiving].includes(state.type)

  return (
    <section className={classNames({ 'xs-s:relative xs-s:-mx-10': showMap }, wrapClassName)}>
      <div className={classNames({ 'xs-s:absolute xs-s:bg-white xs-s:px-10 xs-s:w-full': showMap }, filterOpen ? 'xs-s:z-[110]' : 'xs-s:z-10', { 'xs-s:pb-10': showMap && visible })}>
        <div className={classNames(
          'flex items-center border rounded-sm',
          { 'bg-neutral-2': filterOpen },
          { 'xs-s:h-0 xs-s:overflow-hidden xs-s:!py-0 xs-s:border-0': showMap && !visible },
          className
        )}>
          {
            !isMobile && (
              <>
                {
                  isCommercial && (
                    <>
                      <FilterCategories></FilterCategories>
                      <FilterPrice></FilterPrice>
                      <FilterFloorArea></FilterFloorArea>
                      {/* <FilterLandArea></FilterLandArea> */}
                    </>
                  )
                }
                {
                  isBusiness && (
                    <>
                      <FilterCategories></FilterCategories>
                      <FilterPrice></FilterPrice>
                    </>
                  )
                }
                {
                  isRural && (
                    <>
                      <FilterPrice></FilterPrice>
                      <FilterPropertyType></FilterPropertyType>
                    </>
                  )
                }
                {
                  isVillage && (
                    <>
                      <FilterLivingOptions />
                      <FilterPropertyType></FilterPropertyType>
                      <FilterPrice></FilterPrice>
                    </>
                  )
                }
                {
                  !isCommercial && !isBusiness && !isRural && !isVillage && (
                    <>
                      <FilterPrice></FilterPrice>
                      <FilterBedroom></FilterBedroom>
                      <FilterBathroom></FilterBathroom>
                      <FilterPropertyType></FilterPropertyType>
                    </>
                  )
                }
              </>
            )
          }
          <MoreFilter></MoreFilter>
        </div>
        {
          showMap && (
            <button
              type='button'
              className={classNames(
                'sm:hidden absolute bg-white left-1/2 -translate-x-1/2 text-font-secondary2 w-70 h-30 rounded-b-lg text-sm',
                visible ? 'top-full -mt-1' : 'top-0'
              )}
              onClick={() => toggleVisible()}
            >
              {
                visible
                  ? (
                    <>
                      Less
                      <i className='icon icon-arrow-up ml-4'></i>
                    </>
                  )
                  : (
                    <>
                      More
                      <i className='icon icon-arrow-down ml-4'></i>
                    </>
                  )
              }
            </button>
          )
        }
      </div>
    </section>

  )
}